import { PropsWithChildren } from "react";
import IcReturn from "@/assets/common/ic_arrow_left.svg?react";
import IcClose from "@/assets/common/ic_close.svg?react";
import ReactDOM from "react-dom";

export type ActionSheetProps = PropsWithChildren & {
  title?: string;
  showReturn?: boolean;
  showHeader?: boolean;
  onClose?: (e: React.MouseEvent) => void;
  fullScreen?: boolean;
  onReturn?: (e: React.MouseEvent) => void;
  zIndex?: number;
  className?: string;
  contentClassName?: string;
};

function ActionSheetComponent(props: ActionSheetProps) {
  const {
    fullScreen = false,
    showHeader = true,
    title,
    showReturn = false,
    children,
    onClose,
    zIndex = 1000,
    className,
    contentClassName,
  } = props;

  return (
    <div
      className={`w-full h-full bg-#1F25335C bg-op-36 fixed top-0 left-0 z-${zIndex}`}
    >
      <div
        className={`absolute left-0 w-full flex flex-col  ${
          fullScreen ? "h-full" : "rd-tl-lg rd-tr-lg"
        } bottom-0  min-h-50 bg-mx-white ${className}`}
      >
        {showHeader && (
          <div className="relative h-12.5 flex items-center justify-center border-b-1 border-b-solid border-color-secondary">
            {showReturn ? (
              <IcReturn
                className="absolute w-6 h-6 left-6 top-3.25"
                onClick={onClose}
              />
            ) : (
              <IcClose
                className="absolute w-6 h-6 left-6 top-3.25"
                onClick={onClose}
              />
            )}
            <span className="font-size-4 line-height-4 color-mx-secondary">
              {title}
            </span>
          </div>
        )}
        <div className={`flex-1 ${contentClassName}`}>{children}</div>
      </div>
    </div>
  );
}

function ActionSheet(props: ActionSheetProps & { visible: boolean }) {
  if (!props.visible) return null;
  return ReactDOM.createPortal(
    <ActionSheetComponent {...props} />,
    document.body
  );
}

export default ActionSheet;
